<template>
  <div class="bg-base-200">
    <ul class="menu py-3 min-w-full w-full rounded-md">
      <li class="menu-title mt-2">
        <span class="text-base sm:text-lg">Misafir Menüsü</span>
      </li>
      <li>
        <router-link
          to="/"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath == '/' ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span>Ana Sayfa</span>
        </router-link>
      </li>
      
      <li class="menu-title mt-4">
        <span class="text-base sm:text-lg">Hesap</span>
      </li>
      <li>
        <router-link
          to="/users/login"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/users/login') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
          </svg>
          <span>Giriş Yap</span>
        </router-link>
      </li>
      <li>
        <router-link
          to="/users/signIn"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/users/signIn') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span>Kayıt Ol</span>
        </router-link>
      </li>
      
      <li class="menu-title mt-4">
        <span class="text-base sm:text-lg">Yasal</span>
      </li>
      <li>
        <router-link
          to="/tos"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/tos') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span>Kullanım Koşulları</span>
        </router-link>
      </li>
      <li>
        <router-link
          to="/privacy"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/privacy') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <span>Gizlilik Politikası</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>


<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
</script>

<style scoped>
@media (max-width: 640px) {
  .menu li a {
    min-height: 3rem;
  }
}

.menu-title {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  opacity: 0.6;
  font-weight: 600;
}
</style>